module.exports = __webpack_public_path__ + "ally-book.a06ec805028a5a69a0f5.eot";


//////////////////
// WEBPACK FOOTER
// /home3/usalinks/public_html/ally-book-source/src/assets/less/icons/font/ally-book.eot?92208573
// module id = ../../../../../src/assets/less/icons/font/ally-book.eot?92208573
// module chunks = styles